import { render, staticRenderFns } from "./PatientLabel.vue?vue&type=template&id=2836030d&"
import script from "./PatientLabel.vue?vue&type=script&lang=js&"
export * from "./PatientLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports